import { Translation } from "./translation";

export class CustomFilter {
  Id: number;
  IdGuid: string;
  Name: Translation[];
  Value: string | number;
  Values: { Id: number; Value: string }[];

  constructor(data?: Partial<CustomFilter>) {
    Object.assign(this, data);
  }
}
